// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"c39ccb54","118":"037b8d8f","214":"468b239a","232":"aa018e64","348":"71fe8f08","409":"fb23e3e8","490":"3758833e","660":"717826e4","682":"b88f6bc1","717":"ff134b12","726":"37292d4a","727":"e0461f66"}[chunkId] + ".chunk.js";
};